import { createOpenStore } from "stores/createOpenStore";

export const useMoveTableStore = createOpenStore<{
  tableId: string;
  tableName: string;
}>();
